import React, { useState } from 'react';
import { useFormik } from 'formik';
import * as yup from 'yup';
import { makeStyles } from '@material-ui/core/styles';
import { Container, Box, Link, Typography } from '@material-ui/core';
import Authlayout from '../../hoc/AuthLayout/AuthLayout';
import AuthForm from '../../common/components/AuthForm/AuthForm';
import AuthFormField from '../../common/components/AuthForm/AuthFormField/AuthFormField';
import AuthFormSubmit from '../../common/components/AuthForm/AuthFormSubmit/AuthFormSubmit';
import AuthAlert from '../../common/components/AuthAlert/AuthAlert';
import AuthTextBlock from '../../common/components/AuthTextBlock/AuthTextBlock';
import AuthDialog from '../../common/components/Dialogs/AuthDialog/AuthDialog';
//import { useLazyQuery, useMutation } from '@apollo/client';
//import { useLinkedIn } from 'react-linkedin-login-oauth2';
//import linkedin from 'react-linkedin-login-oauth2/assets/linkedin.png';
//import { Cookies } from 'react-cookie';
//import { GoogleOAuthProvider } from '@react-oauth/google';
//import Google from '../google/google.jsx'
//import Facebook from '../facebook/facebook';
import { useCheckRegistration } from '../../hooks/useCheckRegistration.js';
import { auth } from "../../settings/firebase.js";
import { createUserWithEmailAndPassword } from "firebase/auth";
import { useCreateUser } from '../../hooks/useCreateUser';
import LoadingSpinner from '../../common/components/LoadingSpinner/LoadingSpinner';


const validationSchema = yup.object({
  name: yup
    .string('Enter your name')
    .required('Name is required'),
  surname: yup
    .string('Enter your surname')
    .required('Surname is required'),
  username: yup
    .string('Enter your email')
    .email('Enter a valid email')
    .required('Email is required'),
  password: yup
    .string('Enter your password')
    .min(6, 'Password should be of minimum 6 characters length')
    .max(20, 'Password should be of maximum, 20 characters length')
    .matches(new RegExp('^[a-zA-Z0-9!@#$%^&*)(+=._-]+$'), 'Spaces are not allowed in password field')
    .required('Password is required'),
  termsCondition: yup
    .boolean()
    .oneOf([true], 'Must accept Terms of Use and Privacy Policy'),
});

const useStyles = makeStyles(theme => ({
  container: {
    zIndex: 2
  },
  formLink: {
    color: theme.palette.common.gamsPetroleumBlue,
    textDecoration: 'underline',
  },
  dialogMsg: {
    '& p': {
      marginBottom: 5
    },
    '& p:last-child': {
      marginBottom: 0
    }
  },
  textLink: {
    color: theme.palette.common.gamsPetroleumBlue,
  }
}));
/*
const client = new ApolloClient(apolloConfig);
const LOGIN_WITH_LINKEDIN = gql`
    mutation loginWithLinkedin ($linkedinAccessToken: String){
        loginWithLinkedin(linkedinAccessToken: $linkedinAccessToken){
          _id,
          userRole,
          token
        }
  }
`;
const SIGNUP = gql`
  mutation signup($input:SignUpUserInput){
    signup(input:$input){
      token
    }
  }
`;
const GET_LINKEDIN_AUTHORIZATION = gql`
query getAuthorization($code: String, $redirectUri: String){
    getAuthorization(code: $code, redirectUri: $redirectUri)
  }
`;
const LOGGED_USER = gql`
  query loggedUser {
    user {
      username,
      role
    }
  }
`;*/
const SignUp = props => {
  const classes = useStyles();
  const referral = props.referral ? props.referral : '';
  const [successDialogOpen, setSuccessDialogOpen] = useState(false);
  const [hasError, setHasError] = useState(false);
  const [errorMsg, setErrorMsg] = useState('');
  const [email, setEmail] = useState('');
  const [isCreatingFirebaseUser, setIsCreatingFirebaseUser] = useState(false);
  const { mutateAsync: createUser, isPending: isLoading } = useCreateUser();
  const { mutateAsync: checkRegistration } = useCheckRegistration();
  
  //const [signup] = useMutation(SIGNUP, { client });
  // const [loginWithLinkedin] = useMutation(LOGIN_WITH_LINKEDIN, { client });
  const redirectUri = window.location.protocol + '//' + window.location.host + '/linkedin/authorization';

  /*const { linkedInLogin } = useLinkedIn({
    clientId: '77ia0jbfkyzcou',
    redirectUri,
    scope: 'r_emailaddress r_liteprofile',
    onSuccess: (code) => {
      getLinkedinAuthorization({
        variables: {
          code,
          redirectUri,
        },
      })
    },
    onError: (error) => {
      console.log(error);
    },
  });*/

  const formik = useFormik({
    initialValues: {
      name: '',
      surname: '',
      username: '',
      password: '',
      termsCondition: false,
    },
    validationSchema: validationSchema,
    onSubmit: async (values, { setSubmitting }) => {
      setEmail(values.username);
      
      // Firebase App Check gestisce automaticamente la validazione ReCAPTCHA
      try {
        // Step 1: Check registration status with backend to determine the flow
        const registrationCheck = await checkRegistration(values.username);
        // Case 1: USER_EXISTS - User already exists in backend, show error
        if (registrationCheck.statusCode === 200 && registrationCheck.status === 'USER_EXISTS') {
          setHasError(true);
          setErrorMsg('Email già registrata');
          setSubmitting(false);
          return;
        }
        
        let firebaseUid;
        let shouldSendVerificationEmail = false;
        
        // Case 2: USER_NOT_FOUND - User does not exist in backend, create in Firebase and then in backend
        if (registrationCheck.statusCode === 200 && registrationCheck.status === 'USER_NOT_FOUND') {
          setIsCreatingFirebaseUser(true);
          
          const userCredential = await createUserWithEmailAndPassword(
            auth, 
            values.username, 
            values.password
          );
          
          firebaseUid = userCredential.user.uid;
          shouldSendVerificationEmail = true;
          setIsCreatingFirebaseUser(false);
        }
        // Case 3: FIREBASE_USER_EXISTS - User exists in Firebase but not in backend, use existing Firebase UID to create backend record without sending verification email
        else if (registrationCheck.statusCode === 200 && registrationCheck.status === 'FIREBASE_USER_EXISTS') {
          // The backend provides the existing UID
          firebaseUid = registrationCheck.uid;
          shouldSendVerificationEmail = false;
        }
        // Unexpected case
        else {
          throw new Error('Unrecognized registration status');
        }
        
        // Step 2: Save user data to backend
        try {
          await createUser({
            url: `${window.location.origin}/login`,
            sendMail: shouldSendVerificationEmail, 
            uid: firebaseUid,
            email: values.username,
            name: values.name,
            surname: values.surname,
            privacyPolicy: values.termsCondition,
            courseGroups: [referral] || null
          });
        } catch (backendError) {
          setIsCreatingFirebaseUser(false);
          throw new Error('Errore nel salvataggio dei dati utente');
        }
        
        // Step 3: Invia email di verifica solo se necessario
        /*if (shouldSendVerificationEmail) {
          const user = auth.currentUser;
          if (user) {
            const actionCodeSettings = {
              url: `${window.location.origin}/login`,
              handleCodeInApp: false
            };
            await sendEmailVerification(user, actionCodeSettings);
          }
        }*/
        
        // Mostra dialog di successo
        setHasError(false);
        setSuccessDialogOpen(true);
        setSubmitting(false);
        
      } catch (error) {
        console.error('❌ Signup Error:', error);
        
        setIsCreatingFirebaseUser(false);
        setSuccessDialogOpen(false);
        setHasError(true);
        setSubmitting(false);
        
        // Firebase Error Handling
        let errorMessage = 'Errore durante la registrazione';
        
        if (error.code === 'auth/email-already-in-use') {
          errorMessage = 'Email già registrata';
        } else if (error.code === 'auth/invalid-email') {
          errorMessage = 'Email non valida';
        } else if (error.code === 'auth/weak-password') {
          errorMessage = 'Password troppo debole (minimo 6 caratteri)';
        } else if (error.code === 'auth/operation-not-allowed') {
          errorMessage = 'Registrazione email/password non abilitata';
        } else {
          errorMessage = error.message || 'Errore durante la registrazione';
        }
        
        setErrorMsg(errorMessage);
      }
    },
  });

  const handleSuccessDialogClose = () => {
    setSuccessDialogOpen(false);
  };

  /*function onLinkedinAuthorization(accessToken) {
    loginWithLinkedin({
      variables: {
        linkedinAccessToken: accessToken
      },
    }).then(async (res) => {
      const user = res.data.loginWithLinkedin;
      await afterLogin(
        {
          username: user._id,
          role: user.userRole
        },
        user.token)
    }).catch((error) => {
      console.log(error)
    });
  }*/
  /*const [getLinkedinAuthorization, { loading, error, data }] = useLazyQuery(GET_LINKEDIN_AUTHORIZATION, {
    client,
    fetchPolicy: "network-only",
  });
  if (loading) return 'Loading...';
  if (error) return `Error! ${error.message}`;
  if (data && data.getAuthorization !== null) {
    onLinkedinAuthorization(data.getAuthorization);
  }*/
  /*const afterLogin = async function ({ username, role }, token) {
    setHasError(false);
    const cookies = new Cookies();
    await cookies.set('jwt', token);
    client.writeQuery({
      query: LOGGED_USER,
      data: {
        user: {
          username,
          role,
        },
      },
    });
    window.location.assign('/')
  }*/
  return (
    <>
      <Authlayout>
        <Container maxWidth="md" className={classes.container}>

          {hasError ?
            <AuthAlert errorMsg={errorMsg} />
            : null}

          <AuthForm
            formHandleSubmit={formik.handleSubmit}
            formTitle={'Create your GAMS Platform account'}
            formSubtitle={<AuthTextBlock
              primaryText="You need to be invited to GAMS Platform in order to access it. Ask your Company or School to activate your licence and get your skills validated with the Profile Scorecard and Qualification Scorecard."
              //secondaryText={<strong>Get your 15-days free trial now. </strong>}
              cta={true}
              ctaText="Already have an account?"
              ctaRoute={referral ? `/login?referral=${referral}` : "/login"}
              ctaBtnText="Log In"
            />}
          >
            <AuthFormField
              fieldType={'text'}
              fieldGrid={6}
              fieldName={'name'}
              fieldLabel={'Name'}
              fieldValue={formik.values.name}
              fieldHandleChange={formik.handleChange}
              fieldError={formik.touched.name && Boolean(formik.errors.name)}
              fieldHelperText={formik.touched.name && formik.errors.name}
            />
            <AuthFormField
              fieldType={'text'}
              fieldGrid={6}
              fieldName={'surname'}
              fieldLabel={'Surname'}
              fieldValue={formik.values.surname}
              fieldHandleChange={formik.handleChange}
              fieldError={formik.touched.surname && Boolean(formik.errors.surname)}
              fieldHelperText={formik.touched.surname && formik.errors.surname}
            />
            <AuthFormField
              fieldType={'text'}
              fieldGrid={12}
              fieldName={'username'}
              fieldLabel={'Email'}
              fieldValue={formik.values.username}
              fieldHandleChange={formik.handleChange}
              fieldError={formik.touched.username && Boolean(formik.errors.username)}
              fieldHelperText={formik.touched.username && formik.errors.username}
            />
            <AuthFormField
              fieldType={'password'}
              fieldGrid={12}
              fieldName={'password'}
              fieldLabel={'Password'}
              fieldValue={formik.values.password}
              fieldHandleChange={formik.handleChange}
              fieldError={formik.touched.password && Boolean(formik.errors.password)}
              fieldHelperText={formik.touched.password && formik.errors.password}
              extraStyle={{ marginBottom: 0 }}
            />
            <AuthFormField
              fieldType={'checkbox'}
              fieldGrid={12}
              fieldName={'termsCondition'}
              fieldLabel={
                <>
                  {'I accept the '}
                  <Link
                    className={classes.formLink}
                    href="https://gamsplatform.com/terms-and-conditions"
                    rel="noopener noreferrer"
                    target="_blank"
                  >Terms of Use</Link>
                  {' and '}
                  <Link
                    className={classes.formLink}
                    href="https://gamsplatform.com/privacy-policy"
                    rel="noopener noreferrer"
                    target="_blank"
                  >Privacy Policy</Link>
                </>
              }
              fieldValue={formik.values.termsCondition}
              fieldHandleChange={formik.handleChange}
              fieldError={formik.touched.termsCondition && Boolean(formik.errors.termsCondition)}
              fieldHelperText={formik.touched.termsCondition && formik.errors.termsCondition}
              extraStyle={{ marginBottom: 0, textAlign: 'center' }}
            />
            {(isCreatingFirebaseUser || isLoading) ? (
              <Box display="flex" justifyContent="center" width="100%" mt={2}>
                <LoadingSpinner />
              </Box>
            ) : (
              <AuthFormSubmit
                preBtnText=""
                textSubmit={'Create account'}
                disabled={!referral}
              />
            )}
          </AuthForm>

        </Container>

        <AuthDialog
          emailIcon={true}
          dialogClose={handleSuccessDialogClose}
          dialogOpen={successDialogOpen}
          dialogTitle={'Check your e-mail'}
          dialogMessage={
            <Box
              className={classes.dialogMsg}>
              <Typography variant="body1" component="p">We have sent an email with a confirmation link to {email}.</Typography>
              <Typography variant="body1" component="p">If you do not receive a confirmation email, please check your spam folder. Also, please verify that you entered a valid email address in our sign-up form. </Typography>
              <Typography variant="body1" component="p"> If you need assistance, please contact us at <Link
                className={classes.textLink}
                href="mailto:learn@gamsplatform.com"
                rel="noopener noreferrer">
                learn@gamsplatform.com
              </Link>
              </Typography>
            </Box>
          }
          dialogBtnRouter={true}
          dialogBtnLink={'/login'}
          dialogActions={true}
          dialogBtnText={'Back to login'}
          id="registrationConfirmDialog"
        />
        <Box
          display="flex"
          flexDirection="column"
          alignItems="center"
          paddingTop={5}
          mt={0}
          mb={1.2}
          width="100%"
        >
          {/* LinkedIn login 
          <img
            onClick={linkedInLogin}
            src={linkedin}
            alt="Sign in with LinkedIn"
            style={{ maxWidth: '180px', cursor: 'pointer' }}
          />*/}

          {/* Google login */}
          <div style={{ width: '182px', cursor: 'pointer', marginTop: '5px' }}>
            {/*<GoogleOAuthProvider clientId="918629219103-d59k7qnkieum6rejoin797p9dbk2vsvu.apps.googleusercontent.com">
              <Google />
            </GoogleOAuthProvider>*/}
          </div>

          {/* Facebook login */}
          <div style={{ width: '180px', cursor: 'pointer', marginTop: '5px' }}>
            {/*<Facebook />*/}
          </div>

        </Box>
      </Authlayout>
    </>
  );
}

export default SignUp;
